import Doctor from 'interfaces/Doctor';

export default (doctor: Doctor): boolean => doctor.isAdmin;
